var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingsWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1580_310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#886DF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_linear_1580_310)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "url(#paint1_linear_1580_310)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1562 12.2188H11.7812C11.6569 12.2188 11.5377 12.1694 11.4498 12.0815C11.3619 11.9935 11.3125 11.8743 11.3125 11.75C11.3125 11.6257 11.3619 11.5065 11.4498 11.4185C11.5377 11.3306 11.6569 11.2812 11.7812 11.2812H19.75C19.8743 11.2812 19.9935 11.2319 20.0815 11.144C20.1694 11.056 20.2188 10.9368 20.2188 10.8125C20.2188 10.6882 20.1694 10.569 20.0815 10.481C19.9935 10.3931 19.8743 10.3438 19.75 10.3438H11.7812C11.4083 10.3438 11.0506 10.4919 10.7869 10.7556C10.5232 11.0194 10.375 11.377 10.375 11.75V19.25C10.375 19.623 10.5232 19.9806 10.7869 20.2444C11.0506 20.5081 11.4083 20.6562 11.7812 20.6562H21.1562C21.4049 20.6562 21.6433 20.5575 21.8192 20.3817C21.995 20.2058 22.0938 19.9674 22.0938 19.7188V13.1562C22.0938 12.9076 21.995 12.6692 21.8192 12.4933C21.6433 12.3175 21.4049 12.2188 21.1562 12.2188ZM19.0469 16.9062C18.9078 16.9062 18.7719 16.865 18.6562 16.7878C18.5406 16.7105 18.4505 16.6007 18.3973 16.4722C18.3441 16.3437 18.3301 16.2023 18.3573 16.066C18.3844 15.9296 18.4514 15.8043 18.5497 15.7059C18.648 15.6076 18.7733 15.5406 18.9097 15.5135C19.0461 15.4864 19.1875 15.5003 19.3159 15.5535C19.4444 15.6067 19.5542 15.6969 19.6315 15.8125C19.7088 15.9281 19.75 16.0641 19.75 16.2031C19.75 16.3896 19.6759 16.5684 19.5441 16.7003C19.4122 16.8322 19.2334 16.9062 19.0469 16.9062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1580_310",
    x: 0,
    y: 0.5,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1580_310"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.284122 0 0 0 0 0.00449997 0 0 0 0 0.8955 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1580_310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145413 0 0 0 0 0.0684 0 0 0 0 0.3116 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1580_310",
    result: "effect2_dropShadow_1580_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1580_310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1580_310",
    x1: 16,
    y1: 1.5,
    x2: 16,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1580_310",
    x1: 16,
    y1: 1.5,
    x2: 16,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsWallet);
export default __webpack_public_path__ + "static/media/savingsWallet.267852e7a2770062141fe63e7de6929a.svg";
export { ForwardRef as ReactComponent };